
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.6673 20H20.0007V8.33331C20.0007 7.33331 19.334 6.66665 18.334 6.66665C10.0007 6.66665 3.33398 13.3333 3.33398 21.6666C3.33398 30 10.0007 36.6666 18.334 36.6666C26.6673 36.6666 33.334 30 33.334 21.6666C33.334 20.6666 32.6673 20 31.6673 20ZM20.0007 33.1666C13.6673 34.1666 7.66732 29.6666 6.83398 23.3333C5.83398 17 10.334 11 16.6673 10.1666V21.6666C16.6673 22.6666 17.334 23.3333 18.334 23.3333H29.834C29.1673 28.5 25.1673 32.5 20.0007 33.1666ZM25.0007 3.33331C24.0007 3.33331 23.334 3.99998 23.334 4.99998V15C23.334 16 24.0007 16.6666 25.0007 16.6666H35.0007C36.0007 16.6666 36.6673 16 36.6673 15C36.6673 8.49998 31.5007 3.33331 25.0007 3.33331ZM26.6673 13.3333V6.83331C30.0007 7.49998 32.5007 9.99998 33.1673 13.3333H26.6673Z","fill":"url(#pie_gradient)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"pie_gradient","x1":"3.33398","y1":"3.33331","x2":"40.3703","y2":"8.14106","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"var(--theme-cyan_hc_1_start)"}}),_c('stop',{attrs:{"offset":"1","stop-color":"var(--theme-cyan_hc_1_end)"}})])])])
          )
        }
      }
    